<template>
	<div class="u-link" @click="$emit('click')">
		<slot></slot>
		<span v-if="count > 0">{{count}}</span>
	</div>
</template>

<script>
	export default {
		name: 'topbarLink',

		props: {
			count: [Number, String]
		},

		data() {
			return {
			}
		},

		methods: {
		}
	}
</script>

<style lang="stylus" scoped>
	.u-link {
		position: relative;
		line-height: .6rem;
		font-size: .3rem;

		span {
			position: absolute;
			right: -.2rem;
			top: -.1rem;
			box-sizing: border-box;
			min-width: .32rem;
			border-radius: .16rem;
			padding: 0 .1rem;
			line-height: .32rem;
			font-size: .22rem;
			text-align: center;
			color: #fff;
			background: #FF6600;
		}
	}
</style>
